import { useEffect } from 'react';

let lockCount = 0;

// Prevents the page behind a mobile popup/overlay (nav menu, filter sidebar, etc.)
// from scrolling while the overlay is open. Uses a shared counter so multiple
// overlays can be open independently without one closing early unlocking the other.
export function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (!isLocked) return undefined;
    lockCount += 1;
    document.body.classList.add('no-scroll');
    return () => {
      lockCount -= 1;
      if (lockCount <= 0) {
        lockCount = 0;
        document.body.classList.remove('no-scroll');
      }
    };
  }, [isLocked]);
}
